/**
 * Hook `useLogout` — TH-53155 / M1.E4.S1.4.
 *
 * - POST /api/auth/logout (backend revoga refresh + limpa cookies).
 * - queryClient.clear() — descarta cache de /auth/me e qualquer
 *   dado de tenant que tenha vazado para o cache do TanStack Query.
 * - useTenantSelectionStore().clear() — derruba a seleção do
 *   super_admin (TH-54656) para que o próximo login não herde tenant
 *   "fantasma" caso seja outra conta.
 * - navigate({ to: "/login", replace: true }).
 *
 * Erro de rede no logout não bloqueia o redirect — o pior caso é o
 * cookie ficar válido localmente; mas o backend ainda funciona porque
 * `set_auth_cookies(clear=true)` no logout é idempotente, e
 * `replace:true` evita usuário voltar para a tela autenticada.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import { useTenantSelectionStore } from "@/stores/tenantSelectionStore";

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      await fetch("/api/auth/logout", {
        method: "POST",
        credentials: "include",
      });
    },
    onSettled: () => {
      // Limpa mesmo em caso de erro — UX prefere logout silencioso a
      // usuário preso autenticado por causa de network glitch.
      queryClient.clear();
      useTenantSelectionStore.getState().clear();
      navigate({ to: "/login", replace: true });
    },
  });
}
